<template>
    <ListDialog title="Selecione uma empresa"
                :search-keys="['CD_Comissionado', 'NM_Pessoa']"
                :item-text="descricaoEmpresa"
                :items="items"
                no-search
                :show-close-button="showCloseButton"
                v-bind="$attrs"
                v-on="$listeners" />
</template>

<script>
  export default {
    name: 'DialogEmpresas',
    props: { items: Array, showCloseButton: Boolean },
    methods: {
      descricaoEmpresa (item) {
        return `${item['CD_Empresa']} - ${item['NM_Empresa']}`
      }
    }
  }
</script>

<style scoped>

</style>
